// extracted by mini-css-extract-plugin
export default {"root":"OrderHistoryFilter_root__eyECF"};